import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=e20de2c6&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=ts&"
export * from "./Accueil.vue?vue&type=script&lang=ts&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=e20de2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20de2c6",
  null
  
)

export default component.exports